import { displayNotification, getAPIURL, getBaseURL, sendAPIRequest } from "helpers";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import { useGetMissionPastDocumentsByCountryIDQuery } from "modules/pvs_activities/redux/service/missions";
import DataTable from "pages/components/DataTable";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { MissionContext } from "../contexts/MissionTasksContext";

const MissionPastDocument = ({ typeName }) => {

  const missionContext = useContext(MissionContext);
  const { t } = useTranslation();
  const authToken = useSelector((s) => s.auth.accessToken);
  const { data, isLoading } = useGetMissionPastDocumentsByCountryIDQuery(
    { countryID: missionContext.missionData?.Country?.id },
    {
      skip: ["", null, undefined].includes(missionContext.missionData?.Country?.id),
      refetchOnMountOrArgChange: true,
    }
  );

  return (
    <>
      <div className="header card-woah border border-secondary d-flex btn-res1 px-4 py-2 shadow-sm w-100 my-2">
        <div className="card-title1 lh-1">{t("-1", `${typeName}`)}</div>
      </div>

      <div className="card card-woah border border-secondary shadow rounded-0 mt-0">
        <div className="card-body p-4">
          <DataTable
            getRowId={(row) => row.id}
            isLoading={isLoading}
            className="text-white bg-primary rounded-0"
            rows={data}
            columns={[
              {
                field: "country_name",
                headerName: t("22", "Country"),
                headerClassName: "text-white bg-primary rounded-0",
                minWidth: 150,
                flex: 1,
              },
              {
                field: "report_year",
                headerName: t("-1", "Year"),
                headerClassName: "text-white bg-primary rounded-0",
                minWidth: 150,
                flex: 1,
              },
              {
                field: "document_type",
                headerName: t("-1", "Document Type"),
                valueGetter: (params) => {
                  return params.row?.mission?.mission_type_name;
                },
                headerClassName: "text-white bg-primary rounded-0",
                minWidth: 100,
                flex: 1,
              },
              {
                field: "title",
                headerName: t("-1", "Document Name"),
                headerClassName: "text-white bg-primary rounded-0",
                minWidth: 150,
                flex: 1,
              },
              {
                field: "language",
                headerName: t("-1", "Language"),
                valueGetter: (params) => {
                  return params.row?.language_ref?.list_element_name;
                },
                headerClassName: "text-white bg-primary rounded-0",
                minWidth: 150,
                flex: 1,
              },
              {
                field: "confidentionality_status_ref",
                headerName: t("-1", "Confidentionality Status"),
                valueGetter: (params) => {
                  return params.row?.confidentionality_status_ref?.list_element_name;
                },
                headerClassName: "text-white bg-primary rounded-0",
                minWidth: 150,
                flex: 1,
              },
              {
                field: "actions",
                type: "actions",
                headerClassName: "text-white bg-primary rounded-0",
                headerName: t("-1", "Actions"),
                getActions: (params) => {
                  const actions = [];

                  actions.push(
                    <GridActionsCellItem
                      label={"Download Document"}
                      key={`downloadform-${params.row?.id}`}
                      showInMenu
                      onClick={() =>
                        window.open(
                          getAPIURL(
                            `/api/document-management/download/${params.row?.id}?_token=${authToken}`,
                            "_target"
                          )
                        )
                      }
                    />
                  );

                  return actions;
                },
              },
            ]}
          />
        </div>
      </div>
    </>
  );
};

MissionPastDocument.defaultProps = {
  typeName: "",
};

export default MissionPastDocument;
